module.exports = __webpack_public_path__ + "static/media/premierOneCentralSeatMobileTaken.bb9d4233.svg";